import { api } from './client';
import type { Suggestion, SuggestionStatus, MatchConfig } from '../types';

export const suggestionsApi = {
  list: (status: 'pending' | 'rejected' = 'pending') =>
    api.get<Suggestion[]>(`/suggestions?status=${status}`),
  count: () => api.get<{ count: number }>('/suggestions/count'),
  update: (id: number, status: 'confirmed' | 'rejected' | 'pending') =>
    api.patch<{ id: number; status: SuggestionStatus }>(`/suggestions/${id}`, { status }),
  resetAllRejected: () => api.delete<{ success: boolean }>('/suggestions/rejected'),
  rematch: (config: MatchConfig) =>
    api.post<{ created: number }>('/suggestions/rematch', config),
};
